import AbstractRepository from "@/repositories/AbstractRepository";

export interface BudgetLever {
    budget: number;
    budgetRecommended: number;
    comment?: string;
    support?: string;
    diffusion?: string;
    format?: string;
    lever: Lever;
}

export interface Lever {
    uuid?: string;
    label: string;
    media: {
        label: string;
    };
}

export default class BudgetLeverRepository extends AbstractRepository {
    protected static resource: string = "ptf-socle-budgetlever";

    protected static defaultFields: string[] = [
        "budgetRecommended",
        "budget",
        "campaignBudget.uuid",
        "campaignBudget.label",
        "lever.uuid",
        "lever.label",
        "lever.media.uuid",
        "lever.media.label",
        "comment",
        "support",
        "diffusion",
        "format",
    ];
}
